import { ModalsProvider } from '@mantine/modals';
import type { Result } from '../../../../react-commons/types/result';
import { JwtLoginPage } from '../pages/login/JwtLoginPage';
import { UnauthenticatedAppShell } from './UnauthenticatedAppShell';

export type UnauthenticatedAppJWTProps = {
    login: (credentials: { username: string; password: string }) => Promise<Result<void>>;
};

export const UnauthenticatedAppJWT = ({ login }: UnauthenticatedAppJWTProps) => {
    return (
        <ModalsProvider modalProps={{ zIndex: 2900 }}>
            <UnauthenticatedAppShell>
                <JwtLoginPage login={login} />
            </UnauthenticatedAppShell>
        </ModalsProvider>
    );
};
